import React from "react";
import { isSameDay } from "date-fns";

export default class ReservationsSegmentCheckInRoomSelect extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.initSelect2();
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.room == null &&
        prevProps.room != null &&
        `#room-select-${this.props.selectorId}`) ||
      (this.props.room &&
        this.props.room.id === "unassigned" &&
        prevProps.room &&
        prevProps.room.id != "unassigned" &&
        `#room-select-${this.props.selectorId}`)
    ) {
      $(`#room-select-${this.props.selectorId}`).val("").trigger("change");
    }

    if (
      this.props.room_type.type_of_booking &&
      this.props.room_type.type_of_booking !=
        prevProps.room_type.type_of_booking &&
      !(
        this.props.room_type.type_of_booking == null &&
        prevProps.room_type.type_of_booking == null
      )
    ) {
      $(`#room-select-${this.props.selectorId}`).val("").trigger("change");
      this.initSelect2();
    } else if (
      (this.props.room != null &&
        prevProps.room == null &&
        `#room-select-${this.props.selectorId}` &&
        this.props.room_group) ||
      (this.props.room &&
        this.props.room.id != "unassigned" &&
        prevProps.room &&
        prevProps.room.id == "unassigned" &&
        `#room-select-${this.props.selectorId}` &&
        this.props.room_group) ||
      (prevProps.check_in_date &&
        this.props.check_in_date &&
        !isSameDay(prevProps.check_in_date, this.props.check_in_date)) ||
      (prevProps.check_out_date &&
        this.props.check_out_date &&
        !isSameDay(prevProps.check_out_date, this.props.check_out_date))
    ) {
      $(`#room-select-${this.props.selectorId}`).val("").trigger("change");
      this.initSelect2();
    } else if (
      this.props.room &&
      this.props.room.id != "unassigned" &&
      prevProps.room &&
      prevProps.room.id == "unassigned" &&
      `#room-select-${this.props.selectorId}` &&
      this.props.name == "room_id"
    ) {
      this.initSelect2();
    } else if (
      this.props.room &&
      this.props.room.id != "unassigned" &&
      prevProps.room &&
      prevProps.room.id == "unassigned" &&
      `#room-select-${this.props.selectorId}`
    ) {
      $(`#room-select-${this.props.selectorId}`).val("").trigger("change");
    }
  }

  initSelect2() {
    var self = this;
    if (`#room-select-${this.props.selectorId}`) {
      if ($(`#room-select-${this.props.selectorId}`).data("select2")) {
        $(`#room-select-${this.props.selectorId}`).select2("destroy");
      }

      $(`#room-select-${this.props.selectorId}`)
        .select2({
          ajax: {
            url:
              self.props.room_type &&
              self.props.room_type.type_of_booking == "room_group"
                ? "/admin/room_groups_remote"
                : "/admin/rooms_remote",
            dataType: "json",
            delay: 250,
            data: (params) => {
              return {
                q: params.term,
                page: params.page,
                results_per_page: 40,
                reservation_segment_id: self.props.reservation_segment_id,
                room_type_id: self.props.room_type
                  ? self.props.room_type.id
                  : "",
                taken_room_types: self.props.taken_room_types,
                taken_room_ids: self.props.taken_room_ids,
                room_type_segments: JSON.stringify(
                  self.props.room_type_segments
                ),
                additional_params: {
                  check_in_date: self.props.check_in_date,
                  check_out_date: self.props.check_out_date,
                },
                source: this.props.source ? this.props.source : null,
                room: self.props.room ? self.props.room : {},
              };
            },
            processResults: (data, params) => {
              params.page = params.page || 1;
              for (let i = 0, ilen = data.items.length; i < ilen; i++) {
                if (
                  this.props.source != "ReservationBuilder" &&
                  data.items[i].occupancy_status == "occupied" &&
                  self.state.room &&
                  self.state.room != data.items[i].id
                ) {
                  data.items[i].disabled = true;
                } else if (
                  this.props.source != "ReservationBuilder" &&
                  data.items[i].housekeeping_enabled &&
                  data.items[i].housekeeping_status == "dirty"
                ) {
                  data.items[i].disabled = true;
                } else if (data.items[i].disabled) {
                  data.items[i].disabled = true;
                }
              }

              return {
                results: data.items,
                pagination: {
                  more: params.page * 40 < data.total_count,
                },
              };
            },
            cache: true,
          },
          allowClear: this.props.allowClear ? this.props.allowClear : false,
          escapeMarkup: function (markup) {
            return markup;
          },
          placeholder: I18n.t("not_assigned"),
          templateResult: function (room) {
            return self.renderRoomDetails(room);
          },
          templateSelection: function (room) {
            return self.renderRoomDetails(room);
          },
        })
        .on("select2:unselect", function (e) {
          e.stopPropagation();
          self.props.onChange(null);
        })
        .on("select2:select", function (e) {
          self.props.onChange(e.params.data);
        })
        .val(this.props.room ? this.props.room.id : "")
        .trigger("change");
    }
  }

  render() {
    return (
      <select
        className="form-control"
        id={`room-select-${this.props.selectorId}`}
        style={{ width: "100%", minHeight: 33 }}
      >
        {this.props.room ? (
          <option value={this.props.room.id}>
            {this.renderRoomDetails(this.props.room)}
          </option>
        ) : null}
      </select>
    );
  }

  renderRoomDetails(room) {
    if (room && room.id != null && room.id != "") {
      if (this.props.connected_room_format) {
        if (room.connected_rooms && room.connected_rooms.length) {
          var connected_rooms = room.connected_rooms.map(function (
            connected_room
          ) {
            return connected_room.identifier;
          });
          var markup = room.identifier + " >> " + `(${connected_rooms})`;
          return markup;
        } else {
          return room.identifier || room.text;
        }
      } else if (room.identifier) {
        if (room.identifier == "Not Assigned") {
          return room.identifier;
        } else {
          return (
            room.identifier +
            " - " +
            I18n.t(room.housekeeping_status || "none") +
            " - " +
            I18n.t(room.occupancy_status || "none")
          );
        }
      } else {
        return room.text;
      }
    } else {
      return room.text;
    }
  }
}
